<template>
  <div>
    <slot />
  </div>
</template>

<script>
import {PdlLoading} from '@pedal/pdl-loading';

export default {
  /* Imported Pedal components give accountGarageLayoutPage.jsp access to pdl-loading, but es-lint does 
  not recognize the components are used and errors. The comment below prevents the es-lint error for this file */
  /* eslint-disable vue/no-unused-components */
  components: {
    PdlLoading,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    const bikesGarageForm = this.$refs.form;
    this.$nextTick(() => {
      if (bikesGarageForm) {
        bikesGarageForm.addEventListener('submit', () => {
          this.startLoading();
        });
      }
    });
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
  },
};
</script>
